// extracted by mini-css-extract-plugin
export default {"container":"layers-control_container__pRHlq plainBackgroundColor","smooth-appear":"layers-control_smooth-appear__QXti9","collapsed":"layers-control_collapsed__nnHKt"};